export const brandEyebrowClassName =
  "text-[0.6875rem] font-bold uppercase tracking-[0.18em] text-brand-ink/35";

export const brandAuthTitleClassName =
  "text-[1.875rem] font-bold leading-tight tracking-tight text-brand-ink";

export const brandPageTitleClassName =
  "text-[1.75rem] font-black leading-[1.08] tracking-[-0.03em] text-brand-ink";

export const brandBodyClassName = "text-sm leading-relaxed text-brand-ink/45";
export const brandControlLabelClassName =
  "text-sm font-medium leading-none whitespace-nowrap text-brand-ink/55";

export const brandDialogTitleClassName = "text-lg font-bold text-brand-ink";

export const brandDialogDescriptionClassName = "text-sm text-brand-ink/45";

export const brandDisplayFontStyle = {
  fontFamily: "'Outfit', sans-serif",
} as const;
